import { FOOTBALL_IDENTIFIER, NFL_IDENTIFIER } from '../Sport/Sport';

/**
 * Upload method constants
 */
export const MANUAL_UPLOAD = {
  id: 'MANUAL_UPLOAD',
  requiresTranscoding: false,
};

const VIA_URL = {
  id: 'VIA_URL',
  requiresTranscoding: false,
};

const INTERNAL_SCHEDULED_SYNC = {
  id: 'INTERNAL_SCHEDULED_SYNC',
  requiresTranscoding: false,
};

export const VIA_URL_TRANSCODED = {
  id: 'VIA_URL_TRANSCODED',
  requiresTranscoding: true,
};

export const DEFAULT_UPLOAD_METHOD = VIA_URL;

export const VIDEO_SOURCE_TYPES = {
  CUSTOMER: 'CUSTOMER',
  EXTERNAL_PROVIDER: 'EXTERNAL_PROVIDER',
  INTERNAL_PROVIDER: 'INTERNAL_PROVIDER',
  RECORDED_INTERNALLY: 'RECORDED_INTERNALLY',
};

export const getInternalSources = (intl) => [
  {
    label: intl.formatMessage({
      defaultMessage: 'Global Sports Library',
      id: '174d9',
    }),
    sport: FOOTBALL_IDENTIFIER,
    value: {
      id: 'GSL',
      isLicensed: true,
    },
  },
];

export const getExternalSources = (intl) => [
  {
    label: intl.formatMessage({
      defaultMessage: 'Wyscout',
      id: 'a9a84',
    }),
    sport: FOOTBALL_IDENTIFIER,
    value: {
      id: 'WYSCOUT',
      isLicensed: false,
    },
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Catapult',
      id: '30f54',
    }),
    sport: NFL_IDENTIFIER,
    value: {
      id: 'CATAPULT',
      isLicensed: false,
    },
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Other',
      id: '6311a',
    }),
    value: {
      id: 'OTHER',
      isLicensed: false,
    },
  },
];

export const getRecordingSources = (intl) => [
  {
    label: intl.formatMessage({
      defaultMessage: 'Stream',
      id: 'eae83',
    }),
    value: {
      id: 'IPTV',
      isLicensed: false,
    },
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Satellite',
      id: 'c2b5e',
    }),
    value: {
      id: 'SATELLITE',
      isLicensed: false,
    },
  },
];

export const getVideoSourceNames = (intl) => ({
  EXTERNAL: getExternalSources(intl),
  FREEFORM: 'FREEFORM',
  INTERNAL: getInternalSources(intl),
  RECORDING: getRecordingSources(intl),
});

/**
 * Upload method dropdown options (used in SelectUploadMethod)
 */
export const getUploadMethods = (intl) => [
  {
    label: intl.formatMessage({
      defaultMessage: 'Sync Process',
      id: '9699e',
    }),
    preventManualSelection: true,
    value: INTERNAL_SCHEDULED_SYNC,
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Manual Upload',
      id: 'ba9d9',
    }),
    value: MANUAL_UPLOAD,
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Via URL',
      id: 'd45de',
    }),
    value: VIA_URL,
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Via URL (Transcode)',
      id: '0f249',
    }),
    value: VIA_URL_TRANSCODED,
  },
];

/**
 * Source Type Dropdown options (used in SelectSourceType)
 */
export const getSourceOptions = (intl) => [
  {
    label: intl.formatMessage({
      defaultMessage: 'Customer',
      id: 'ce266',
    }),
    value: {
      sourceNames: getVideoSourceNames(intl).FREEFORM,
      sourceType: VIDEO_SOURCE_TYPES.CUSTOMER,
    },
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'External Provider',
      id: 'b58ea',
    }),
    value: {
      sourceNames: getVideoSourceNames(intl).EXTERNAL,
      sourceType: VIDEO_SOURCE_TYPES.EXTERNAL_PROVIDER,
    },
  },
  {
    label: intl.formatMessage({
      defaultMessage: 'Recorded Internally',
      id: '2d05a',
    }),
    value: {
      sourceNames: getVideoSourceNames(intl).RECORDING,
      sourceType: VIDEO_SOURCE_TYPES.RECORDED_INTERNALLY,
    },
  },
];
